<template lang="pug">
include ../../plugins/pug/template
div
  DataTable(
    :headers="tableHeaders"
    :preference-key="preferenceKey"
    :constructor-activator="constructorInHeader && tableKey ? '#table-constructor-' + tableKey : ''"
    :itemRoute="linkCells && detailedRoute ? getItemRoute : null"
    :keyboardRows="copyCells && !!detailedRoute"
    :items="items"
    :item-class="rowClass"
    :items-per-page="pageSize"
    :loading="isLoad"
    loading-text="Завантаження..."
    no-results-text="Дані не знайдено"
    no-data-text="Даних немає"
    hide-default-footer
    :server-items-length="countItems || (Array.isArray(items) ? items.length : 0)"
    :options.sync="options"
    @click:row="openDetails"
    @keydown:row="openDetails"
    @columns-change="$emit('columns-change', $event)"
  )
    template(
      v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="slotProps"
    )
      slot(
        :name="slotName"
        v-bind="slotProps"
      )
    template(#header.status_statement)
      //- Vuetify додає стрілку сортування поруч зі слотом, тому контейнер має бути рядковим.
      span.d-inline-flex.align-center
        span {{ $t('status') }}
        //- заготовка для відкриття модального вікна де будуть розписані всі статуси які є у таблиці і що вони значать
        //- v-tooltip(bottom open-delay="200")
        //-   template(v-slot:activator="{ on, attrs }")
        //-     v-btn(icon)
        //-       v-icon(size="16" v-bind="attrs" v-on="on") mdi-information-outline
          span Натисніть, щоб ознайомитись
    template(#item.markWithModel="{ item }")
      div.text--primary.b-600.white-space-nowrap {{ vehicleName(item) }}

    template(#item.vehicle_mark="{ item }")
      span.text--primary.b-600 {{ directoryById('vehicleMark', item.vehicle_mark).name }}

    template(#item.vehicle_model="{ item }")
      span.text--primary.b-600 {{ directoryById('vehicleModel', item.vehicle_model).name }}

    template(#item.created_at="{ item }")
      slot(name="item.created_at" :item="item")
        span.text--primary.b-600 {{ item.created_at ? $moment(item.created_at).format('HH:mm DD.MM.YYYY') : '--' }}

    template(#item.expiry="{ item }")
      span.text--primary.b-600 {{ $moment(item.expiry).format('HH:mm DD.MM.YYYY') }}

    template(#item.last_activity="{ item }")
      span.text--primary.b-600 {{ $moment(item.last_activity).format("HH:mm DD.MM.YYYY") }}

    template(#item.is_current_session="{ item }")
      span.text--primary.b-600 {{ item.is_current_session ? $t('yes') : $t('no') }}

    template(#item.clientAbbr="{ item }")
      span.text--primary.b-600 {{ item.client_full_name }}

    template(#item.userFIO="{ item }")
      span.text--primary.b-600 {{ clientFIO(item) }}

    template(#item.laboratory="{ item }")
      div.text--primary.b-600
        div {{ item.laboratoryBranchOffice.name }}
      div.text--primary.b-600
        div {{ item.laboratoryBranchOffice.address }}

    template(#item.branchAddress="{ item }" )
      div.text--primary.b-600 {{ branchAddress(item.address) }}

    template(#item.categoriesVehicle="{ item }")
      span.text--primary.b-600 {{ categoriesVehicle(item.allow_categories || []) }}

    template(#item.userPassports="{ item }")
      div.text--primary.b-600 {{ passportData(item.user_passports[0]) }}

    template(#item.legal_acts="{ item }")
      div.mb-1(:key="i" v-for="(act, i) in item.legal_acts").text--primary.b-600
        div {{ directoryById('legalActs', act).inspection_name }}
        div {{ directoryById('legalActs', act).name }}

    template(#item.direction="{ item }")
      v-chip(class="ma-2 font-weight-bold" :color="directionContractStatement(item).color" small)
        span.mr-1 {{ $t(directionContractStatement(item).text) }}
        v-icon(small) {{directionContractStatement(item).icon}}

    template(#item.organizationEDRPOU="{ item }")
      div.text--primary.b-600 {{ organizationEDRPOU(item) }}

    template(#item.organizationName="{ item }")
      div.text--primary.b-600 {{ organizationName(item) }}

    template(#item.status_statement="{ item }")
      StatementStatus(:key="item.id" :statement="item" text-tooltip)

    template(#item.status_statement_manual="{ item }")
      StatusChip(:status="statuses.statementManual(item.status_document)" text-tooltip)

    template(#item.status_statement_mti="{ item }")
      StatusChip(:status="statuses.statementMTI(item.status_document)" text-tooltip)

    template(#item.status_contract="{ item }")
      StatusChip(:status="statuses.contractDecision(item.decision)" text-tooltip)

    template(#item.status_statement_branch="{ item }")
      StatusChip(v-if="item.statement_step" :status="statuses.statementBranch(item.statement_step)" text-tooltip)
      StatusChip(v-else-if="item.is_updating" :status="{ color: 'orange', text: 'waitingModeration' }" text-tooltip)
      StatusChip(v-else :status="statusWorkLine(item.has_moderation_lines)" text-tooltip)

    template(#item.last_name_employee="{ item }")
      div.d-flex
        v-tooltip(bottom v-if="item.has_rejected_reviews || item.has_rejected_files_reviews")
          template(v-slot:activator="{ on, attrs }")
            v-icon(color="error" v-bind="attrs" v-on="on").mr-4 mdi-alert-circle
          span(v-html="$t('wrongField.employeeHasWrongField', { name: `${item.last_name} ${item.first_name} ${item.middle_name}` })")
        span {{ item.last_name }}

    template(#item.branch_name="{ item }")
      div.d-flex
        v-tooltip(bottom v-if="item.has_rejected_reviews || item.has_rejected_files_reviews")
          template(v-slot:activator="{ on, attrs }")
            v-icon(color="error" v-bind="attrs" v-on="on").mr-4 mdi-alert-circle
          span(v-html="$t('wrongField.branchHasWrongField', { name: item.name })")
        span {{ item.name }}

    template(#item.status_cooperation_agreement="{ item }")
      v-tooltip(
        v-if="item.is_expire_soon && item.contract_status === 1"
        bottom
        open-delay="200"
      )
        template(v-slot:activator="{ on, attrs }")
          v-badge(
            bordered
            overlap
            :color="'error'"
            :content="'!'"
            v-bind="attrs"
            v-on="on"
          ).mr-6
            v-chip(:color="statuses.cooperationAgreement(item.contract_status).color" v-bind="attrs" v-on="on")
              span.text--white.b-600 {{ $t(statuses.cooperationAgreement(item.contract_status).text) }}
        div {{ $t(statuses.cooperationAgreement(item.contract_status).text) }}
        span {{ item.is_expire_soon ? $t('contract.needsExtension', [Math.ceil($moment(new Date(item.contract_end_date)).diff($moment(new Date()), 'days', true))]) : $t('statuses.statementDecisionValid') }}
      StatusChip(v-if="!item.is_expire_soon || item.contract_status === 2" :status="statuses.cooperationAgreement(item.contract_status)" text-tooltip)

    template(#item.action="{ item }")
      router-link(:to="detailedRoute + item.id ")
        v-icon(color="info") mdi-arrow-right

    template(#item.view="{ item }")
      +btn-icon('primary', 'mdi-eye')(@click="$emit('view', item.id)")

    template(#item.delete="{ item }")
      v-icon(color="error" @click="$emit('delete', item.pk_md5 ? item.pk_md5 : item.id)") mdi-delete

    template(#item.edit="{ item }")
      +btn-icon('primary', 'mdi-pencil')(@click="$emit('edit', item.id)")

    template(#item.actionBranch="{ item }")
      +btn-icon('error', 'mdi-delete')(@click="$emit('deleteBranch', item.id)" v-if="!item.has_rejected_reviews && !item.has_rejected_files_reviews" )
      +btn-icon('primary', 'mdi-pencil')(@click="$emit('editBranch', item.id)" v-if="item.has_rejected_reviews || item.has_rejected_files_reviews")

    template(#item.employeeStatus="{ item }")
      StatusChip(:status="statuses.employeeStatus(employeeStatus(item))" text-tooltip)

    template(#item.employeeOutOfSystemStatus="{ item }")
      StatusChip(:status="statuses.employeeOutOfSystemStatus(employeeStatus(item))" text-tooltip)

    template(#item.employeeDeactivationAndActivation="{ item }")
      v-tooltip(bottom open-delay="200" v-if="item.user_status === 1 || [1, 2].includes(item.statement_employee_status)")
        template(v-slot:activator="{ on, attrs }")
          +btn-icon('error', 'mdi-delete')(@click="$emit('delete', item.id)" v-on="on")
        span {{ $t('btn.deactivate') }}

      v-tooltip(bottom open-delay="200" v-if="[2, 3].includes(item.user_status) || item.statement_employee_status === 4")
        template(v-slot:activator="{ on, attrs }")
          +btn-icon('success lighten-1', 'mdi-delete-restore')(@click="$emit('restore', item.id)" v-on="on")
        span {{ $t('btn.activate') }}

    template(#item.userAction="{ item }")
      v-tooltip(bottom open-delay="200" v-if="item.user_status === 1")
        template(v-slot:activator="{ on, attrs }")
          +btn-icon('error', 'mdi-delete')(@click="$emit('delete', item.id)" v-on="on")
        span {{ $t('btn.remove') }}

      v-tooltip(bottom open-delay="200" v-if="[2, 3].includes(item.user_status)")
        template(v-slot:activator="{ on, attrs }")
          +btn-icon('success lighten-1', 'mdi-delete-restore')(@click="$emit('restore', item.id)" v-on="on")
        span {{ $t('btn.restore') }}

      v-tooltip(bottom open-delay="200")
        template(v-slot:activator="{ on, attrs }")
          router-link(:to="detailedRoute + item.id").px-2
            v-icon(color="primary" v-on="on") mdi-pencil
        span {{ $t('btn.edit') }}

      v-tooltip(bottom open-delay="200")
        template(v-slot:activator="{ on, attrs }")
          router-link(:to="detailedRoute + item.id + '/view' ").px-2
            v-icon(color="primary" v-on="on") mdi-eye
        span {{ $t('btn.view') }}

    template(#item.type_user_translate="{ item }")
      div {{ userRoleName(item.type_user) }}
    template(#footer v-if="countItems")
      TableFooter(
        :page="page"
        :page-size="pageSize"
        :count-items="countItems"
        :label-page="labelPage"
        @page-change="changeCurrentPage"
        @page-size-change="changeCount"
      )
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { access } from '@/configs/permissions'
import statuses from '@/configs/statuses'
import { list as statusesList } from '@/configs/statuses'
import { employeeType, roleNameListUserVL, streetTypeAbbr } from '@/configs/constants'
import getLabelTypeStreet from '@/mixins/getLabelTypeStreet'
import DataTable from '@/components/table/DataTable.vue'
import TableFooter from '@/components/table/TableFooter.vue'
import StatementStatus from '@/components/Statement/StatementStatus.vue'

const actionColumns = new Set([
  'action', 'view', 'delete', 'edit', 'actionBranch', 'employeeDeactivationAndActivation', 'userAction'
])

export default {
  components: { DataTable, TableFooter, StatementStatus },
  mixins: [getLabelTypeStreet],
  props: {
    headers: { type: Array, default: () => ([]) },
    tableKey: { type: String, default: '' },
    constructorInHeader: { type: Boolean, default: false },
    items: { type: Array, default: () => ([]) },
    detailedRoute: { type: String, default: '' },
    copyCells: { type: Boolean, default: false },
    linkCells: { type: Boolean, default: false },
    changePage: { type: Function, default: () => {} },
    useServerOptions: { type: Boolean, default: false },
    tableOptions: { type: Object, default: null },
    isLoad: { type: Boolean, default: false },
    isHideHeader: { type: Boolean, default: false },
    countItems: { type: Number, default: 0 },
    labelPage: { type: String, default: 'record' }
  },
  data () {
    return {
      statuses,
      statusesList,
      page: 1,
      check: false,
      access,
      employeeType,
      roleNameListUserVL,
      pageSize: 10,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
      }
    }
  },
  computed: {
    ...mapState({}),
    ...mapGetters(['directoryById']),
    preferenceKey () {
      const profile = this.$store.state.profile.profile
      if (profile.id == null || !this.tableKey) return ''
      return JSON.stringify([profile.id, profile.type_user, this.tableKey])
    },
    tableHeaders () {
      return this.headers.map(header => {
        const action = actionColumns.has(header.value)
        const status = /status/i.test(header.value)
        const width = action ? (header.value === 'userAction' ? 150 : 100) : status ? 260
          : /date|created_at|expiry|activity/.test(header.value) ? 160
            : header.value === 'number' ? 120 : 200
        return {
          ...header,
          width: header.width || width,
          sortable: action ? false : header.sortable,
          copyable: action || status ? false : header.copyable,
          truncate: action || status || header.value === 'direction' ? false : header.truncate,
          linkable: action ? false : header.linkable
        }
      })
    },
    branchAddress () {
      return address => {
        if (!address) {
          return ''
        }
        const parts = []
        if (address.index) {
          parts.push(`${ address.index }`)
        }
        if (address.city) {
          parts.push(`м. ${ address.city }`)
        }
        if (address.region) {
          parts.push(`${ address.region }`)
        }
        if (address.street) {
          const streetTypeKey = this.getLabelTypeStreet(address.type_street)
          const streetLabel = streetTypeKey && streetTypeAbbr[streetTypeKey] !== undefined
            ? streetTypeAbbr[streetTypeKey]
            : (streetTypeKey ? this.$t(streetTypeKey) : '')
          const formattedStreet = streetLabel
            ? `${ streetLabel } ${ address.street }`
            : `${ address.street }`
          parts.push(formattedStreet.trim())
        }
        if (address.house) {
          parts.push(`буд.${ address.house }`)
        }
        if (address.flat) {
          parts.push(`кв.${ address.flat }`)
        }
        return parts.join(', ')
      }
    },
    clientFIO () {
      return user => {
        return `${ user.last_name } ${ user.first_name } ${ user.middle_name }`
      }
    },
    categoriesVehicle () {
      return categories => {
        if (categories.length && typeof categories[0] === 'number') {
          let categoriesNameString = []
          categories.forEach(e => categoriesNameString.push(this.directoryById('vehicleCategory', e)?.name))
          return categoriesNameString.join(', ')
        }
        return categories.join(', ')
      }
    },
    passportData () {
      return userPassportData => userPassportData ?
        `${ userPassportData.serial } / ${ userPassportData.inn }` :
        '--- / ---'
    },
    organizationName () {
      return item => {
        if (this.access('viewContractLabInfo')) {
          return item.sender.certification_agency ? item.consumer.name : item.sender.name
        }
        if (this.access('viewContractOCInfo')) {
          return item.sender.measuring_laboratory ? item.consumer.name : item.sender.name
        }
      }
    },
    organizationEDRPOU () {
      return item => {
        if (this.access('viewContractLabInfo')) {
          return item.sender.certification_agency ? item.consumer.EDPROU : item.sender.EDPROU
        }
        if (this.access('viewContractOCInfo')) {
          return item.sender.measuring_laboratory ? item.consumer.EDPROU : item.sender.EDPROU
        }
      }
    },
    directionContractStatement () {
      return item => {
        if (this.access('viewContractLabInfo')) {
          return item.sender.certification_agency
            ? { icon: 'mdi-arrow-top-right-thin', text: 'contract.directionOut', color: 'green lighten-3' }
            : { icon: 'mdi-arrow-bottom-left-thin', text: 'contract.directionIn', color: 'yellow lighten-3' }
        }
        if (this.access('viewContractOCInfo')) {
          return item.sender.measuring_laboratory
            ? { icon: 'mdi-arrow-top-right-thin', text: 'contract.directionOut', color: 'green lighten-3' }
            : { icon: 'mdi-arrow-bottom-left-thin', text: 'contract.directionIn', color: 'yellow lighten-3' }
        }
      }
    },
    employeeStatus () {
      // eslint-disable-next-line no-bitwise
      return item => item.user_status | item.statement_employee_status
    },

    statusWorkLine () {
      return hasModerationLines => {
        if (hasModerationLines) {
          return this.statuses.workLineStatus(this.statusesList.workLineWaitFilling)
        }
        return this.statuses.workLineStatus(this.statusesList.workLineApproved)
      }
    },
    userRoleName () {
      return typeUser => roleNameListUserVL.find(e => e.type_user === typeUser)?.role
    }
  },
  watch: {
    tableOptions: {
      handler (options) {
        if (!this.useServerOptions || !options) return
        this.page = options.page
        this.pageSize = options.itemsPerPage
        this.options = {
          ...this.options,
          ...options,
          sortBy: [...options.sortBy],
          sortDesc: [...options.sortDesc]
        }
      },
      deep: true,
      immediate: true
    },
    options: {
      handler (val) {
        if (!this.useServerOptions) return
        this.page = val.page
        this.pageSize = val.itemsPerPage
        this.$emit('update:options', val)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['getDirectoryById']),
    vehicleName (item) {
      return [item.vehicle_mark_name, item.vehicle_model_name, item.vehicle_modification_name]
        .map(value => String(value ?? '').trim().replace(/\s+/g, ' '))
        .filter(Boolean)
        .join(' ')
    },
    rowClass (item) {
      return item.has_rejected_reviews || item.has_rejected_files_reviews ? 'table-row--rejected' : ''
    },
    getItemRoute (item) {
      return this.detailedRoute + item.id
    },
    openDetails (item, _row, event) {
      if (!this.copyCells || !this.detailedRoute) return
      if (event?.defaultPrevented) return
      if (event && event.target.closest('a, button, input, select, textarea, [role="button"]')) return
      if (event?.type !== 'keydown' && window.getSelection()?.toString()) return
      this.$router.push(this.detailedRoute + item.id)
    },
    clientNameFormatted (fullName) {
      if (fullName && fullName.replace(/^\s+|\s+$/gm, '')) {
        const name = fullName.split(' ')
        let middleName = name[2][0] ? `${ name[2][0] }.` : ''
        return `${ name[0] } ${ name [1][0] }. ${ middleName }`
      }
      return '---'
    },
    changeCount (item) {
      this.pageSize = item
      this.page = 1
      if (this.useServerOptions) {
        this.options = {
          ...this.options,
          page: this.page,
          itemsPerPage: item
        }
      } else {
        this.changePage(this.page, item)
      }
    },
    changeCurrentPage (page) {
      this.page = page
      if (this.useServerOptions) {
        this.options = {
          ...this.options,
          page: this.page
        }
      } else {
        this.changePage(this.page, this.pageSize)
      }
    }
  }
}
</script>
